import styles from "./BusinessContinuityPolicyPage.module.css";

const BusinessContinuityPolicyPage = () => {
  return (
    <div className={styles.container}>
      <h2>ΠΟΛΙΤΙΚΗ ΕΠΙΧΕΙΡΗΣΙΑΚΗΣ ΣΥΝΕΧΕΙΑΣ</h2>

      <p>
        Η Εταιρεία, όπως και κάθε άλλη επιχείρηση, είναι εκτεθειμένη σε πιθανούς
        κινδύνους που θα μπορούσαν να βλάψουν ή και να καταστρέψουν κρίσιμες
        επιχειρηματικές λειτουργίες ή / και των υπηρεσιών της Εταιρείας.
      </p>

      <p>Η εταιρεία THE RECORDS HUB S.A. προσφέρει τις παρακάτω υπηρεσίες:</p>
      <ul>
        <li>ΑΣΦΑΛΗ ΨΗΦΙΟΠΟΙΗΣΗ ΑΡΧΕΙΩΝ.</li>
        <li>ΑΣΦΑΛΗ ΦΥΛΑΞΗ ΑΡΧΕΙΩΝ ΠΕΛΑΤΩΝ.</li>
        <li>ΑΣΦΑΛΗ ΚΑΤΑΣΤΡΟΦΗ ΑΡΧΕΙΩΝ.</li>
        <li>
          ΣΥΜΒΟΥΛΕΥΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΓΙΑ ΤΗ ΔΙΑΧΕΙΡΙΣΗ ΑΡΧΕΙΩΝ (RECORDS
          MANAGEMENT).
        </li>
        <li>ΣΥΜΒΟΥΛΕΥΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ DPO / GDPR.</li>
      </ul>

      <p>
        Η Διοίκηση της εταιρείας αναγνωρίζει τους κινδύνους που υπάρχουν και
        απειλούν την επιχειρησιακή της συνέχεια, σε κρίσιμες επιχειρηματικές της
        λειτουργίες και δεσμεύεται να παρέχει όλους τους απαιτούμενους πόρους
        ώστε να εφαρμόζεται ένα Σύστημα Διαχείρισης της Επιχειρησιακής Συνέχειας
        σύμφωνα με το διεθνές πρότυπο ISO 22301:2019.
      </p>

      <p>
        Η στρατηγική της εταιρείας για τη συνέχιση των δραστηριοτήτων της, σε
        περίπτωση επέλευσης ενός καταστροφικού περιστατικού, είναι να
        εξασφαλίσει την ασφάλεια και την προστασία όλων των εργαζομένων και να
        συνεχίσει να παρέχει τις κρίσιμες επιχειρηματικές της λειτουργίες, την
        παραγωγή και την παράδοση των προϊόντων και υπηρεσιών από
        προκαθορισμένες εναλλακτικές τοποθεσίες.
      </p>

      <h3>Στρατηγικοί στόχοι της εταιρείας είναι:</h3>
      <ul>
        <li>
          Η ανάπτυξη και η εφαρμογή πολιτικών και διαδικασιών ώστε να
          διασφαλίζεται η επιχειρησιακή συνέχεια των υπηρεσιών που προσφέρονται
          προς τους πελάτες της.
        </li>
        <li>
          Η συνέχιση της εξυπηρέτησης των πελατών της μετά από εμφάνιση
          περιστατικού που επηρεάζει τις λειτουργίες ή/και τις υπηρεσίες της.
        </li>
        <li>
          Η συμμόρφωση με τις κανονιστικές και νομικές υποχρεώσεις και τις
          υποχρεώσεις που προέρχονται από τις συμφωνίες με τους πελάτες.
        </li>
        <li>
          Η συστηματική αποτίμηση και αξιολόγηση των κινδύνων που αφορούν στη
          διασφάλιση της επιχειρησιακής συνέχειας, προσβλέποντας στην ορθή και
          έγκαιρη διαχείρισή τους.
        </li>
        <li>
          Η συνεχής ενημέρωση και εκπαίδευση της διοίκησης και του προσωπικού σε
          θέματα επιχειρησιακής συνέχειας.
        </li>
        <li>
          Η προστασία των συμφερόντων της Εταιρείας και όσων συναλλάσσονται με
          αυτήν.
        </li>
        <li>
          Η ενθάρρυνση της εσωτερικής και εξωτερικής επικοινωνίας σχετικά με τα
          θέματα επιχειρησιακής συνέχειας.
        </li>
        <li>
          Η διασφάλιση της αποτελεσματικότητας του Συστήματος επιχειρησιακής
          συνέχειας μέσα από συνεχείς ελέγχους και δοκιμές του συστήματος.
        </li>
      </ul>

      <p>
        Η Διοίκηση δεσμεύεται στη διάθεση των πόρων που κρίνονται απαραίτητοι
        για τη μη διακοπή των εργασιών της και τη διασφάλιση της επιχειρησιακής
        συνέχειας της εταιρίας. Κάθε εργαζόμενος είναι υπεύθυνος να
        ανταποκρίνεται, να αφομοιώνει και να εφαρμόζει τις διαδικασίες που
        απαιτεί το Σύστημα Διαχείρισης Επιχειρησιακής Συνέχειας μέσα από τις
        καθημερινές δραστηριότητές του. Για το λόγο αυτό όλοι οι εργαζόμενοι,
        ανάλογα με τις αρμοδιότητές τους, ενημερώνονται σχετικά με το Σύστημα
        και ενεργούν σύμφωνα με τα οριζόμενα.
      </p>

      <p>
        Η Πολιτική Διαχείρισης Επιχειρησιακής Συνέχειας είναι κοινοποιημένη,
        κατανοητή και εφαρμόσιμη από το σύνολο του ανθρώπινου δυναμικού, με
        απώτερο σκοπό τη συνεχή, σταθερή ανάπτυξη της επιχειρηματικής
        δραστηριότητάς της, με αταλάντευτη προσήλωση στις αρχές της και τη
        διαρκή και αδιάκοπη προσφορά στους πελάτες της υπηρεσιών αρίστης
        ποιότητας και μέγιστης ασφάλειας.
      </p>

      <p>
        Το Σύστημα Επιχειρησιακής Συνέχειας εγκρίθηκε από τη Διεύθυνση της
        εταιρείας. Η παραπάνω Πολιτική αναθεωρείται μια φορά τον χρόνο κατά την
        διάρκεια της Ανασκόπησης από την Διοίκηση με στόχο τη συνεχή εναρμόνισή
        της με τις συνθήκες της αγοράς, τις καθημερινές εξελίξεις και την
        κείμενη νομοθεσία.
      </p>
    </div>
  );
};

export default BusinessContinuityPolicyPage;
